import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from '../../../common/services/local-storage.service';
import { RouteStateService, UserProfileService } from '../../../core/services';
import { SessionStorageService } from '../../../core/services/session-storage.service';
import { isNullOrEmpty } from '../../../core/utils';
import { UserProfile } from '../../../models/common';
import { AuditInfo } from '../../../models/rt-common/audit-info';
import { LocalStorageEnum } from '../../enums';
import { SessionStorageEnum } from '../../enums/session-storage.enum';
import { getDeptId } from '../user-profile-utils';

@Injectable()
export class AuditInfoInterceptor implements HttpInterceptor {
  constructor(
    private _sessionStorageService: SessionStorageService,
    private _localStorageService: LocalStorageService,
    private userProfileService: UserProfileService,
    private routeStateService: RouteStateService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // Clone the request and replace the original headers with
    // cloned headers, updated with the authorization.
    if (globalThis.sigv.appContext.sigvRetailConfig.disableHttpInterceptor) {
      return next.handle(req);
    }
    const useAuditInfo = this._sessionStorageService.getItem(
      SessionStorageEnum.AUDIT_INFO_KEY
    ) as AuditInfo;
    //取得公司別
    const contextData = this._sessionStorageService.getItem(
      SessionStorageEnum.CONTEXT_DATA
    );
    if (contextData) {
      useAuditInfo.companyId = contextData?.companyId;
    } else {
      useAuditInfo.companyId =
        this.routeStateService.router.getCurrentNavigation()?.extras?.state?.[
          'routeState'
        ]?.data?.companyId;
    }
    //取得所屬部門
    if (!useAuditInfo.deptId) {
      useAuditInfo.deptId = getDeptId(this.userProfileService);
    }
    if (!useAuditInfo.userNo) {
      try {
        const useUserProfile = this._localStorageService.getItem(
          LocalStorageEnum.USER_INFO_STORAGE_KEY
        ) as UserProfile;
        useAuditInfo.userNo = useUserProfile.userNo;
      } catch (error) { }
    }
    try {
      useAuditInfo.language =
        this._localStorageService.getItem(
          LocalStorageEnum.CURRENT_LANGUAGE_LOCALE_STORAGE_KEY
        ) ?? 'en-us';
    } catch (error) {
      useAuditInfo.language = 'en-us';
    }

    let authReq = req.clone({
      headers: req.headers.set('X-Audit-Info', JSON.stringify(useAuditInfo)),
    });

    if (
      (globalThis.sigv.appContext.envConfig as any)?.['isUseSubmissionToken'] ==
      true &&
      ['RetailWebSubmission'].includes(
        globalThis.sigv.appContext.projectConfig.systemCode
      ) &&
      !isNullOrEmpty(this._sessionStorageService.getItem('idToken'))
    ) {
      authReq = req.clone({
        headers: req.headers.set(
          'Authorization',
          'Bearer ' + this._sessionStorageService.getItem('idToken') || ''
        ),
      });
    }
    // send cloned request with header to the next handler.
    return next.handle(authReq);
  }
}
